import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=0fa99ae5&scoped=true"
import script from "./ModalRoot.vue?vue&type=script&lang=js"
export * from "./ModalRoot.vue?vue&type=script&lang=js"
import style0 from "./ModalRoot.vue?vue&type=style&index=0&id=0fa99ae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa99ae5",
  null
  
)

export default component.exports